import React, { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types';

import Error from '../../Error/Error'

import { COMMON_ERROR } from '../../../translations'

import styles from './CommentsPanel.module.css'

export default class CommentsPanel extends Component {
    static propTypes = {
        fetchItemsCommentsPanel: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.props.fetchItemsCommentsPanel()
    }

    renderItem(item) {
        return
    }

    render() {
        if (this.props.comments.isError) {
            return <Error>{COMMON_ERROR}</Error>
        }

        return this.props.comments.items.length === 0 && !this.props.comments.isFetching ? (
                <Error>Комментарии не найдены</Error>
            ) : (
                <div className={classNames(styles.boxes, "jsGridView")}>
                    {/* {this.props.filtered.items.map((item)) => { this.renderItem(item)) }} */}
                    {this.props.comments.items.map((item) => this.renderItem(item))}
                </div>
            )
    }
}
